import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: 1.6rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
  }
`
